import Page from "webPage/Page";
import CanvasImage from "CanvasImage";
import Ajax from "base/Ajax";
import AjaxForm, { EVENT_ERROR, EVENT_SUCCESS } from "webPage/AjaxForm";

Page.register('/take-action', function () {

    let form = new AjaxForm($(".js-take-action"), ($form, formData) => {
        return Ajax.post("equip", "take-action", formData, Ajax.WEBSITE);
    }, {
        validatorSettings: {
            inputOptions: {operator: "your"},
            inputs: {
                "g-recaptcha-response": {
                    messages: {
                        empty: "Please complete the recaptcha",
                    },
                },
            },
        },
    });

    form.on(EVENT_ERROR, () => {
        grecaptcha.reset();
    });

    form.on(EVENT_SUCCESS, () => {
        $(".js-content-wrap").hide();
        $(".js-take-action-success").show();
        $(document).scrollTop($(".js-take-action").offset().top - $(".header").outerHeight() - $(".header").position().top - 50)
    });

    window.onRecaptchaLoad = function () {
        form.validator.updateInputs();
    };


    $("body").on("change", "input:checkbox, input:radio", function () {
        let $fieldset = $(this).parents("fieldset");

        if ($fieldset.find("input").filter(":radio,:checkbox").filter("[value='Other']").is(":checked")) {
            $fieldset.find(".form__row--other").removeClass("form__row--hidden").find("input").removeAttr("disabled");
        } else {
            $fieldset.find(".form__row--other").addClass("form__row--hidden").find("input").attr("disabled", true);
        }
    });

    $(".form__row--other").addClass("form__row--hidden").find("input").attr("disabled", true);
    $("input:checkbox,input:radio").filter(":checked").change();

    $(window).on("scroll resize", updateSticky);

    function updateSticky() {
        let $sidebar = $(".take-action__contact-info");
        if ($sidebar.length !== 1) return;

        let $header = $(".header");
        let headerHeight = $header.position().top + $header.outerHeight();

        if ($(window).outerWidth() < 760 || $(window).height() < $sidebar.outerHeight() + headerHeight || window.navigator.userAgent.indexOf("Edge") > -1) {
            $sidebar.removeClass("take-action__contact-info--bottom take-action__contact-info--top take-action__contact-info--sticky").css("left", "").css("width", "");
            return;
        }

        let $list = $(".take-action__row");

        let scrollTop = $(window).scrollTop() + headerHeight + 25;
        let scrollBottom = scrollTop + $sidebar.outerHeight() - 5;

        let listTop = $list.offset().top;
        let listBottom = listTop + $list.outerHeight();

        if (scrollTop < listTop) {
            //At top
            $sidebar.removeClass("take-action__contact-info--bottom take-action__contact-info--sticky").addClass("take-action__contact-info--top").css("left", "").css("width", "");
        } else if (scrollBottom > listBottom) {
            //At bottom
            $sidebar.removeClass("take-action__contact-info--top take-action__contact-info--sticky").addClass("take-action__contact-info--bottom").css("left", "").css("width", "");
        } else {
            //Sticky
            let maxWidth = $sidebar.css("max-width");

            let widthParts = /^([0-9.]+)%$/.exec(maxWidth);
            let width = widthParts === null ? '' : (parseFloat(widthParts[1]) / 100 * $list.outerWidth() + "px");
            if (/^([0-9.]+)px$/.test(maxWidth)) {
                width = maxWidth;
            }

            $sidebar.removeClass("take-action__contact-info--top take-action__contact-info--bottom").css("left", $list.offset().left + $list.outerWidth() - $sidebar.width()).addClass("take-action__contact-info--sticky").css("width", width);
        }
    }

    updateSticky();

    let masksProcess = {
        0: [
            {
                'url': '/images/png/masks/home/process/home-process-mask--top.png',
                'vPos': 'top',
                'hPos': 'center'
            },
            {
                'url': '/images/png/masks/home/process/home-process-mask--bottom.png',
                'vPos': 'bottom',
                'hPos': 'center'
            }
        ],
        600: [
            {
                'url': '/images/png/masks/home/process/home-process-mask--top.png',
                'vPos': 'top',
                'hPos': 'center'
            },
            {
                'url': '/images/png/masks/home/process/home-process-mask--bottom.png',
                'vPos': 'bottom',
                'hPos': 'center'
            }
        ],
        960: [
            {
                'url': '/images/png/masks/home/process/home-process-mask--top.png',
                'vPos': 'top',
                'hPos': 'center'
            },
            {
                'url': '/images/png/masks/home/process/home-process-mask--bottom.png',
                'vPos': 'bottom',
                'hPos': 'center'
            }
        ],
        1400: [
            {
                'url': '/images/png/masks/home/process/home-process-mask--top.png',
                'vPos': 'top',
                'hPos': 'center'
            },
            {
                'url': '/images/png/masks/home/process/home-process-mask--bottom.png',
                'vPos': 'bottom',
                'hPos': 'center'
            }
        ]
    };

    let masksContent = {
        0: [
            {
                'url': '/images/png/masks/content/content-mask--mobile.png',
                'vPos': 'top'
            }
        ],
        600: [
            {
                'url': '/images/png/masks/content/content-mask--600.png',
                'vPos': 'top'
            }
        ],
        1200: [
            {
                'url': '/images/png/masks/content/content-mask.png',
                'vPos': 'top'
            }
        ]
    };


    new CanvasImage($('.content__img'), masksContent);
    new CanvasImage($('.process__background'), masksProcess);
});
